import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import type { ReactElement } from 'react';
import { Trans } from 'react-i18next';

import { initialsOf } from '../../../components/ChannelAvatar';

/**
 * "Invited by <affiliate>" with the initials of the name (specs/S3-intro/spec.md R3, mockup 2).
 *
 * The name is the affiliate's display name only (I8). It is user data: `Trans` interpolates it as
 * text, so a name that looks like markup stays text (AC14), and it wraps instead of overflowing.
 * Colours come from the theme (R9); the avatar is decorative because the name is written beside it.
 */
export function AffiliateBadge({ name }: { name: string }): ReactElement {
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        px: 1.5,
        py: 1.25,
        borderRadius: 3,
        bgcolor: theme.fx.infoBg,
      })}
    >
      <Avatar
        aria-hidden
        sx={{
          width: 32,
          height: 32,
          fontSize: 13,
          fontWeight: 600,
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
        }}
      >
        {initialsOf(name)}
      </Avatar>
      <Box component="span" sx={{ fontSize: 14, overflowWrap: 'anywhere' }}>
        <Trans
          i18nKey="onboarding.intro.invitedBy"
          values={{ name }}
          components={{ strong: <strong /> }}
        />
      </Box>
    </Box>
  );
}
